module.exports = function() {
  function hasAcrobatInstalled() {
    function getActiveXObject(name) {
      try { return new ActiveXObject(name); } catch(e) {}
    };

    return getActiveXObject('AcroPDF.PDF') || getActiveXObject('PDF.PdfCtrl');
  }
 
  if (navigator.mimeTypes['application/pdf'] || hasAcrobatInstalled()) {
    return true;
  } else {
    return false;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/browser-pdf-support/index.js
// module id = 1240
// module chunks = 0